module.exports = __webpack_public_path__ + "static/img/weapp-header-light.d1838332.png";